import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { namespace } from "vuex-class";
import * as humanizeDuration from 'humanize-duration'
import {
  BM_ACTION,
  BM_ARCHIVE_MEETING,
  BM_DELETE_COMMENT, BM_DELETE_COMMENT_MEDIA,
  BM_DELETE_CONTRACTOR,
  BM_DELETE_IB,
  BM_DELETE_MEETING,
  BM_DELETE_PARTICIPANT, BM_DELETE_PLAN,
  BM_EDIT_COMMENT_BY_FIELD,
  BM_EDIT_CONTRACTOR_BY_FIELD, BM_EDIT_IB_BY_FIELD,
  BM_EDIT_MEETING,
  BM_EDIT_PARTICIPANT_BY_FIELD, BM_EDIT_PLAN_BY_FIELD, BM_GENERATE_REPORT,
  BM_GET_MEETING,
  BM_GET_MEETING_PLAN,
  BM_LOADERS,
  BM_MODULE_NAMESPACE, BM_OPEN_CLOSE_COMMENT, BM_PATCH_COMMENT,
  BM_PATCH_CONTRACTOR,
  BM_PATCH_PARTICIPANT,
  BM_POST_COMMENT, BM_POST_COMMENT_MEDIA,
  BM_POST_CONTRACTOR,
  BM_POST_IB,
  BM_POST_MEDIA,
  BM_POST_PARTICIPANT, BM_POST_PLAN,
  BM_SAVE_DOCUMENT,
  BM_SET_LOADER_STATE
} from "../../../store/building-monitor/bm-types.store";
import { ActivityStatus, CrudStatus } from "../../../common/enums";
import { IBMMeetingDetailViewModel } from "../../../models/bm/bm-meeting-detail.viewmodel";
import { DateTimeHelper } from "../../../utils/DateTimeHelper.util";
import { BMService } from "../../../services";
import { Uris } from "../../../common/constants";
import { AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE } from "../../../store/authorization";
import { BMParticipantEditedViewModel } from "../../../models/bm/bm-participant-edited.viewmodel";
import { BMContractorEditedViewModel } from "../../../models/bm/bm-contractor-edited.viewmodel";
import { BMCommentEditedViewModel } from "../../../models/bm/bm-comment-edited.viewmodel";
import { DOCUMENT_MODULE_NAMESPACE, DOCUMENT_RESET_DOCUMENT } from "../../../store/document";
import { BMPlanEditedViewModel } from "../../../models/bm/bm-plan-edited.viewmodel";
import { IDocument } from "../../../models/documents/document";
import { BMIBEditedViewModel } from "../../../models/bm/bm-ib-edited.viewmodel";

const BMStore = namespace(BM_MODULE_NAMESPACE)
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)
const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)

@Component({
  components: {
    'user-profile-enhanced-widget': async () => import('@/components/user-profile-enhanced-widget/UserProfileEnhancedWidget.vue'),
    'user-profile-widget': async () => import('../components/bm-user-profile-widget/BMUserProfileWidget.vue'),
    'block-infos-loader': async () => import('../loaders/block-infos-loader/BlockInfosLoader.vue'),
    'participant-modal-vertical': async () => import('../components/bm-participant-modal-vertical/BMParticipantModalVertical.vue'),
    'contractor-modal-vertical': async () => import('../components/bm-contractor-modal-vertical/BMContractorModalVertical.vue'),
    'ib-modal-vertical': async () => import('../components/bm-ib-modal-vertical/BMIBModalVertical.vue'),
    'comment-modal-vertical': async () => import('../components/bm-comment-modal-vertical/BMCommentModalVertical.vue'),
    'plan-modal-vertical': async () => import('../components/bm-plan-modal-vertical/BMPlanModalVertical.vue'),
    'ib-item': async () => import('../components/bm-ib-item/BMIBItem.vue'),
    'plan-marker-modal-vertical': async () => import('../components/bm-plan-marker-modal-vertical/BMPlanMarkerModalVertical.vue'),
  },
})
class BMMeetingDetail extends Vue {

  @BMStore.Getter activityStatus: ActivityStatus;
  @BMStore.Getter bmMeeting: { activityStatus: ActivityStatus, data: IBMMeetingDetailViewModel };
  @BMStore.Getter loaders: Map<string, boolean>
  @BMStore.Getter bmMeetingPlan: any[]
  @BMStore.Getter bmCrudActionStatus: CrudStatus
  @BMStore.Getter bmParticipantEdited: BMParticipantEditedViewModel
  @BMStore.Getter bmCommentEdited: BMCommentEditedViewModel
  @BMStore.Getter bmContractorEdited: BMContractorEditedViewModel
  @BMStore.Getter bmPlanEdited: BMPlanEditedViewModel
  @DocumentStore.Getter document: IDocument

  @BMStore.Action(BM_GET_MEETING)
  storeGetBMMeeting: (payload: { bmId: string, idm: string }) => Promise<any>;
  @BMStore.Action(BM_GET_MEETING_PLAN)
  storeGetBMMeetingPlan: (payload: { bmId: string, idm: string }) => Promise<any>;
  @BMStore.Action(BM_EDIT_MEETING)
  storeEditMeeting: () => void
  @BMStore.Action(BM_DELETE_MEETING)
  storeDeleteMeeting: (payload: { bmid: string, idm: string }) => Promise<any>;
  @BMStore.Action(BM_ARCHIVE_MEETING)
  storeArchiveMeeting: (payload: { bmid: string, idm: string }) => Promise<any>;
  @BMStore.Action(BM_POST_PARTICIPANT)
  storePostParticipant: (payload: { bmid: string, idm: string }) => Promise<any>;
  @BMStore.Action(BM_PATCH_PARTICIPANT)
  storePatchParticipant: (payload: { bmid: string, idm: string, idp: string, source: any }) => Promise<any>;
  @BMStore.Action(BM_DELETE_PARTICIPANT)
  storeDeleteParticipant: (payload: { bmid: string, idm: string, idp: string }) => Promise<any>;
  @BMStore.Action(BM_POST_CONTRACTOR)
  storePostContractor: (payload: { bmid: string, idm: string, idi: string }) => Promise<any>;
  @BMStore.Action(BM_PATCH_CONTRACTOR)
  storePatchContractor: (payload: { bmid: string, idm: string, idi: string, idc: string, source: any }) => Promise<any>;
  @BMStore.Action(BM_PATCH_COMMENT)
  storePatchComment: (payload: { bmid: string, idm: string, idi: string, idc: string, originalComment: any }) => Promise<any>;
  @BMStore.Action(BM_OPEN_CLOSE_COMMENT)
  storeOpenCloseComment: (payload: { bmid: string, idm: string, idi: string, idc: string, cmtState: string }) => Promise<any>;
  @BMStore.Action(BM_DELETE_CONTRACTOR)
  storeDeleteContractor: (payload: { bmid: string, idm: string, idi: string, idc: string }) => Promise<any>;
  @BMStore.Action(BM_POST_IB)
  storePostIB: (payload: { bmid: string, idm: string }) => Promise<any>;
  @BMStore.Action(BM_POST_MEDIA)
  storePostMedia: (payload: any) => Promise<any>;
  @BMStore.Action(BM_POST_COMMENT_MEDIA)
  storePostCommentMedia: (payload: any) => Promise<any>;
  @BMStore.Action(BM_POST_COMMENT)
  storePostComment: (payload: { bmid: string, idm: string, idi: string }) => Promise<any>;
  @BMStore.Action(BM_DELETE_IB)
  storeDeleteIB: (payload: { bmid: string, idm: string, idi: string }) => Promise<any>;
  @BMStore.Action(BM_DELETE_PLAN)
  storeDeletePlan: (payload: { bmid: string, idm: string, idp: string, force?: boolean }) => Promise<any>;
  @BMStore.Action(BM_DELETE_COMMENT_MEDIA)
  storeDeleteCommentMedia: (payload: { bmid: string, idm: string, idi: string, idc: string, idf: string }) => Promise<any>;
  @BMStore.Action(BM_DELETE_COMMENT)
  storeDeleteComment: (payload: { bmid: string, idm: string, idi: string, idc: string }) => Promise<any>;
  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;
  @DocumentStore.Action(DOCUMENT_RESET_DOCUMENT)
  storeResetDocument: () => void
  @BMStore.Action(BM_SAVE_DOCUMENT)
  storeSaveDocument: (payload: IDocument) => Promise<any>;
  @BMStore.Action(BM_POST_PLAN)
  storePostPlan: (payload: { bmid: string, idm: string, plan?: any }) => Promise<any>;
  @BMStore.Action(BM_GENERATE_REPORT)
  storeGenerateReport: (payload: { bmid: string, idm: string, signatures?: any[] }) => Promise<any>;

  @BMStore.Mutation(BM_EDIT_PLAN_BY_FIELD)
  storeSetPlanByField: (payload: { [key: string]: any }) => void
  @BMStore.Mutation(BM_SET_LOADER_STATE)
  storeSetLoaderState: (payload: { key: string, value: boolean }) => void
  @BMStore.Mutation(BM_ACTION)
  storeSetBMAction: (action: CrudStatus) => void
  @BMStore.Mutation(BM_EDIT_PARTICIPANT_BY_FIELD)
  storeSetBMParticipantEdited: (payload: { [key: string]: any }) => void
  @BMStore.Mutation(BM_EDIT_CONTRACTOR_BY_FIELD)
  storeSetBMContractorEdited: (payload: { [key: string]: any }) => void
  @BMStore.Mutation(BM_EDIT_COMMENT_BY_FIELD)
  storeSetBMCommentEdited: (payload: { [key: string]: any }) => void
  @BMStore.Mutation(BM_EDIT_IB_BY_FIELD)
  storeSetBMIBEdited: (payload: { [key: string]: any }) => void

  readonly LOADING_MEETING_PARTICIPANTS: {}[] = Array.from(new Array(2)).map(item => ({}))

  dtStyle: any | null
  dtCanRender: boolean
  dtMessageErrorModel: boolean
  dtErrorModalVisible: boolean;
  dtError: any
  dtActionOpen: boolean
  dtIsLoading: boolean
  dtMenu: boolean
  _cleatTimeout: any
  comments: any[]
  dtOpenBaseModal: boolean
  dtBaseModalLoading: boolean
  dtBaseModalAction: string
  dtDeleteAction: string
  ActionModal: {
    PlanAdd: string,
    PlanUp: string,
    PlanSelect: string
    MemberAdd: string,
    MemberUp: string,
    ContractorAdd: string,
    ContractorUp: string,
    IBAdd: string,
    IBUp: string,
    GenerateReport: string,
    CommentAdd: string,
    CommentUp: string,
    NoAction: string
  }
  ActionDelete: {
    Plan: string,
    PlanForce: string,
    Member: string,
    Contractor: string,
    IB: string,
    Comment: string,
    CommentMedia: string,
    OpenCloseCmt: string,
    NoAction: string,
  }
  dtItemSelected: any
  dtAttachments: any[]
  dtSignatures: any[]
  dtPlan: {
    items: any[],
    selected: any,
    comment: any
  }

  constructor() {
    super()
    this.dtStyle = null
    this.dtErrorModalVisible = false
    this.dtError = null
    this.dtCanRender = false
    this.dtMessageErrorModel = false
    this.dtMenu = false
    this.dtActionOpen = false
    this.dtIsLoading = false
    this.comments = []
    this.dtOpenBaseModal = false
    this.dtBaseModalLoading = false
    this.ActionModal = {
      PlanAdd: 'PLAN_ADD',
      PlanUp: 'PLAN_UP',
      PlanSelect: 'PLAN_SELECT',
      MemberAdd: 'MEMBER_ADD',
      MemberUp: 'MEMBER_UP',
      ContractorAdd: 'CONTRACTOR_ADD',
      ContractorUp: 'CONTRACTOR_UP',
      IBAdd: 'IB_ADD',
      IBUp: 'IB_UP',
      GenerateReport: 'GENERATE_REPORT',
      CommentAdd: 'COMMENT_ADD',
      CommentUp: 'COMMENT_UP',
      NoAction: 'NO_ACTION'
    }
    this.ActionDelete = {
      Plan: 'PLAN',
      PlanForce: 'PLAN_FORCE',
      Member: 'MEMBER',
      Contractor: 'CONTRACTOR',
      IB: 'IB',
      Comment: 'COMMENT',
      CommentMedia: 'COMMENT_MEDIA',
      OpenCloseCmt: 'OPEN_CLOSE_COMMENT',
      NoAction: 'NO_ACTION'
    }
    this.dtBaseModalAction = 'NO_ACTION'
    this.dtDeleteAction = 'NO_ACTION'
    this.dtItemSelected = null
    this.dtAttachments = []
    this.dtPlan = {
      items: [],
      selected: null,
      comment: null
    }
  }

  get lblSetting() {
    return {
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/block').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/button').default
    }
  }

  get isGenerateReport(): boolean {
    return !!this.bmMeeting.data.media_pdf
  }

  get coFile(): number[] {
    return this.bmCommentEdited.medias
  }

  set coFile(value) {
    this.storeSetBMCommentEdited({ medias: value })
  }

  get coMeetingDetailLoader(): boolean {
    return this.loaders.get(BM_LOADERS.DETAILS)
  }

  get coMeetingPlanLoader(): boolean {
    return this.loaders.get(BM_LOADERS.PLANS)
  }

  get participansContact(): any[] {
    if (!this.bmMeeting.data.participants) return []
    return this.bmMeeting.data.participants
      .map(participant => ({
        ...participant,
        entity: {
          ...participant.entity,
          fullname: `${participant.entity.firstname} ${participant.entity.lastname}`.trim()
        }
      }))
  }

  get participansContactIndexer() {
    return this.coMeetingDetailLoader ? this.LOADING_MEETING_PARTICIPANTS : this.participansContact.map((contact, index) => index).filter(index => index % 2 === 0)
  }

  get meetingName() {
    return this.$t(this.lblSetting.bmMeetingName, { date: DateTimeHelper.parseDate(this.bmMeeting.data.date_start) })
  }

  get isOpenDeleteMessage(): boolean {
    return this.bmCrudActionStatus === CrudStatus.Delete ||
      this.bmCrudActionStatus === CrudStatus.Archive || this.dtDeleteAction !== this.ActionDelete.NoAction
  }

  get deleteModalText(): string {
    if (this.bmCrudActionStatus === CrudStatus.Delete) {
      return this.$t(this.lblSetting.bmDeleteBtn) + ' ' + this.meetingSourceName
    } else if (this.bmCrudActionStatus === CrudStatus.Archive) {
      return (this.bmMeeting.data.is_archived ? this.$t(this.lblSetting.bmUnarchiveBtn) : this.$t(this.lblSetting.bmArchiveBtn)) + ' la ' + this.meetingSourceName
    } else {
      switch (this.dtDeleteAction) {
        case this.ActionDelete.Member:
          return this.$t(this.lblSetting.bmDeleteMember) + ' ' + this.dtItemSelected.entity.fullname
        case this.ActionDelete.Plan:
          return this.$t(this.lblSetting.bmDeletePlan) + ' ' + this.dtItemSelected.media.name
        case this.ActionDelete.Contractor:
          return this.$t(this.lblSetting.bmDeleteContractor) + ' ' +
            this.dtItemSelected.contractor.entity.firstname +
            this.dtItemSelected.contractor.entity.lastname
        case this.ActionDelete.Comment:
          return this.$t(this.lblSetting.bmDeleteComment) + ' "' + this.dtItemSelected.subject + '"'
        case this.ActionDelete.CommentMedia:
          return this.$t(this.lblSetting.bmDeleteCommentMedia) + ' ' + this.dtItemSelected.media.name
        case this.ActionDelete.OpenCloseCmt:
          if (this.dtItemSelected.state === 'open')
            return this.$t(this.lblSetting.bmCloseComment) + ' "' + this.dtItemSelected.subject + '"'
          else
            return this.$t(this.lblSetting.bmOpenComment) + ' "' + this.dtItemSelected.subject + '"'
        case this.ActionDelete.IB:
          return this.$t(this.lblSetting.bmDeleteIB) + ' ' + this.dtItemSelected.character_problem.name
        case this.ActionDelete.PlanForce:
          return this.dtItemSelected.message
      }
    }
    return ''
  }

  get meetingSourceName(): string {
    if (!this.bmMeeting.data) return ''
    return this.$t(this.lblSetting.bmMeetingName, { date: DateTimeHelper.parseDate(this.bmMeeting.data.date_start) }) + ''
  }

  get modalBtnTitle(): string {
    return this.lblSetting.lblConfirm
  }

  get modalTitle(): string {
    switch (this.dtBaseModalAction) {
      case this.ActionModal.MemberAdd:
        return this.lblSetting.bmAddParticipant
      case this.ActionModal.MemberUp:
        return this.lblSetting.bmUpParticipant
      case this.ActionModal.PlanAdd:
        return this.lblSetting.bmAddPlan
      case this.ActionModal.ContractorAdd:
        return this.lblSetting.bmAddContractor
      case this.ActionModal.ContractorUp:
        return this.lblSetting.bmUpContractor
      case this.ActionModal.CommentAdd:
        return this.lblSetting.bmAddComment
      case this.ActionModal.CommentUp:
        return this.lblSetting.bmUpComment
      case this.ActionModal.IBAdd:
        return this.lblSetting.bmAddIB
      case this.ActionModal.GenerateReport:
        return this.lblSetting.bmGenerateReport
      default:
        return ''
    }
  }

  get dtShowDeleteBtn(): boolean {
    switch (this.dtBaseModalAction) {
      case this.ActionModal.MemberUp:
      case this.ActionModal.ContractorUp:
      case this.ActionModal.CommentUp:
        return true
      default: return false
    }
  }

  created() { }

  mounted() {
    this.loadFunctionality()
    this.getCurrentMeeting()
    this.getPlanMeeting()
  }

  loadFunctionality() {
    this.storeGetFunctionalities(BM_MODULE_NAMESPACE)
      .then(response => {
        if (this.$route.meta) {
          Object.keys(response).forEach(key => {
            this.$route.meta[key] = true
          })
        }
      })
      .catch(error => console.log(error))
  }

  handleDeleteCancel() {
    this.storeSetBMAction(CrudStatus.NoAction)
    this.dtDeleteAction = this.ActionDelete.NoAction
  }

  handleDeleteOK() {
    this.dtIsLoading = true
    if (this.bmCrudActionStatus === CrudStatus.Delete) {
      this.storeDeleteMeeting({ bmid: this.$route.params.id, idm: this.$route.params.idm })
        .then(() => {
          this.$router.replace(Uris.BMMeetingBase
            .replace(':id', this.$route.params.id))
        })
        .catch(err => {
          this.dtMessageErrorModel = true
          this.dtError = err
        })
        .finally(() => {
          this.storeSetBMAction(CrudStatus.NoAction)
          this.dtIsLoading = false
        })
    } else if (this.bmCrudActionStatus === CrudStatus.Archive) {
      this.storeArchiveMeeting({ bmid: this.$route.params.id, idm: this.$route.params.idm })
        .then(() => {
          this.$router.replace(Uris.BMMeetingBase
            .replace(':id', this.$route.params.id))
        })
        .catch(err => {
          this.dtMessageErrorModel = true
          this.dtError = err
        })
        .finally(() => {
          this.storeSetBMAction(CrudStatus.NoAction)
          this.dtIsLoading = false
        })
    } else {
      switch (this.dtDeleteAction) {
        case this.ActionDelete.Member:
          this.storeDeleteParticipant({
            bmid: this.$route.params.id,
            idm: this.$route.params.idm,
            idp: this.dtItemSelected.id.toString()
          })
            .then(response => {
              this.dtOpenBaseModal = false
              this.dtDeleteAction = this.ActionDelete.NoAction
              // update content for participant
              // this.getCurrentMeeting()
            })
            .catch(err => {
              this.dtErrorModalVisible = true
              this.dtError = err
              this.dtIsLoading = false
            })
            .finally(() => this.dtIsLoading = false)
          break
        case this.ActionDelete.Plan:
          this.storeDeletePlan({
            bmid: this.$route.params.id, idm: this.$route.params.idm, idp: this.dtItemSelected.id
          })
            .then(response => {
              this.dtOpenBaseModal = false
              this.dtDeleteAction = this.ActionDelete.NoAction
              this.getPlanMeeting()
            })
            .catch(err => {
              if (err.code === 406) {
                this.dtItemSelected.message = err.message
                this.dtDeleteAction = this.ActionDelete.PlanForce
              } else {
                this.dtErrorModalVisible = true
                this.dtError = err
              }
            })
            .finally(() => this.dtIsLoading = false)
          break
        case this.ActionDelete.PlanForce:
          this.storeDeletePlan({
            bmid: this.$route.params.id, idm: this.$route.params.idm, idp: this.dtItemSelected.id, force: true
          })
            .then(response => {
              this.dtOpenBaseModal = false
              this.dtDeleteAction = this.ActionDelete.NoAction
              this.getPlanMeeting()
            })
            .catch(err => {
              this.dtErrorModalVisible = true
              this.dtError = err
            })
            .finally(() => this.dtIsLoading = false)
          break
        case this.ActionDelete.Contractor:
          this.storeDeleteContractor({
            bmid: this.$route.params.id,
            idm: this.$route.params.idm,
            idi: this.dtItemSelected.fk_bm_inspection_bundle.toString(),
            idc: this.dtItemSelected.id
          })
            .then(response => {
              this.dtOpenBaseModal = false
              this.dtDeleteAction = this.ActionDelete.NoAction
              // update content for participant
              // this.getCurrentMeeting()
            })
            .catch(err => {
              this.dtErrorModalVisible = true
              this.dtError = err
            })
            .finally(() => this.dtIsLoading = false)
          break
        case this.ActionDelete.Comment:
          this.storeDeleteComment({
            bmid: this.$route.params.id,
            idm: this.$route.params.idm,
            idi: this.dtItemSelected.ibId.toString(),
            idc: this.dtItemSelected.id
          })
            .then(response => {
              this.dtOpenBaseModal = false
              this.dtDeleteAction = this.ActionDelete.NoAction
              // update content for participant
              this.refreshComment(this.dtItemSelected.ibId)
            })
            .catch(err => {
              this.dtErrorModalVisible = true
              this.dtError = err
            })
            .finally(() => this.dtIsLoading = false)
          break
        case this.ActionDelete.OpenCloseCmt:
          let stateCmt = 'open'
          if (this.dtItemSelected.state === 'open')
            stateCmt = 'close'
          this.storeOpenCloseComment({
            bmid: this.$route.params.id,
            idm: this.$route.params.idm,
            idi: this.dtItemSelected.ibId.toString(),
            idc: this.dtItemSelected.id,
            cmtState: stateCmt
          })
            .then(response => {
              this.dtOpenBaseModal = false
              this.dtDeleteAction = this.ActionDelete.NoAction
              // update content for participant
              this.refreshComment(this.dtItemSelected.ibId)
            })
            .catch(err => {
              this.dtErrorModalVisible = true
              this.dtError = err
            })
            .finally(() => this.dtIsLoading = false)
          break
        case this.ActionDelete.CommentMedia:
          this.storeDeleteCommentMedia({
            bmid: this.$route.params.id,
            idm: this.$route.params.idm,
            idi: this.dtItemSelected.ibId.toString(),
            idc: this.dtItemSelected.cmtId.toString(),
            idf: this.dtItemSelected.id.toString()
          })
            .then(response => {
              this.dtOpenBaseModal = false
              this.dtDeleteAction = this.ActionDelete.NoAction
              // update content for participant
              this.refreshComment(this.dtItemSelected.ibId)
            })
            .catch(err => {
              this.dtErrorModalVisible = true
              this.dtError = err
            })
            .finally(() => this.dtIsLoading = false)
          break
        case this.ActionDelete.IB:
          this.storeDeleteIB({
            bmid: this.$route.params.id, idm: this.$route.params.idm, idi: this.dtItemSelected.id
          })
            .then(response => {
              this.dtOpenBaseModal = false
              this.dtDeleteAction = this.ActionDelete.NoAction
              // update content for participant & contractor
              // this.getCurrentMeeting()
            })
            .catch(err => {
              this.dtErrorModalVisible = true
              this.dtError = err
            })
            .finally(() => this.dtIsLoading = false)
          break
      }
    }
  }

  openBaseModal(action: string, data: any = null) {
    if (this.isGenerateReport && this.dtBaseModalAction !== this.ActionModal.PlanSelect) return
    this.dtBaseModalAction = action
    this.dtItemSelected = data
    this.dtOpenBaseModal = true
    switch (this.dtBaseModalAction) {
      case this.ActionModal.MemberAdd:
        this.openParticipantAdd()
        break
      case this.ActionModal.PlanAdd:
        this.openPlanAdd()
        break
      case this.ActionModal.ContractorAdd:
        this.openContractorAdd()
        break
      case this.ActionModal.CommentAdd:
        this.openCommentAdd()
        break
      case this.ActionModal.IBAdd:
        this.openIBAdd()
        break
      case this.ActionModal.MemberUp:
        this.openParticipantUp(data)
        break
      case this.ActionModal.PlanUp:
        this.openPlanUp(data)
        break
      case this.ActionModal.PlanSelect:
        this.openPlanSelector(data)
        break
      case this.ActionModal.ContractorUp:
        this.openContractorUp(data)
        break
      case this.ActionModal.CommentUp:
        this.openCommentUp(data)
        break
      case this.ActionModal.IBUp:
        this.openIBUp(data)
        break
      case this.ActionModal.GenerateReport:
        this.openGenerateReport()
        break
    }
  }

  openDeleteItem() {
    switch (this.dtBaseModalAction) {
      case this.ActionModal.MemberUp:
        this.dtDeleteAction = this.ActionDelete.Member
        break
      case this.ActionModal.PlanUp:
        this.dtDeleteAction = this.ActionDelete.Plan
        break
      case this.ActionModal.ContractorUp:
        this.dtDeleteAction = this.ActionDelete.Contractor
        break
      case this.ActionModal.CommentUp:
        this.dtDeleteAction = this.ActionDelete.Comment
        break
      case this.ActionModal.IBUp:
        this.dtDeleteAction = this.ActionDelete.IB
        break
      default:
        this.dtDeleteAction = this.ActionDelete.NoAction
    }
  }

  openDeleteImageComment(file) {
    this.dtItemSelected = file
    this.dtDeleteAction = this.ActionDelete.CommentMedia
  }

  openDeletePlan(plan) {
    this.dtItemSelected = plan
    this.dtDeleteAction = this.ActionDelete.Plan
  }

  openDeleteIB(ib) {
    this.dtItemSelected = ib
    this.dtDeleteAction = this.ActionDelete.IB
  }

  openCloseComment() {
    this.dtDeleteAction = this.ActionDelete.OpenCloseCmt
  }

  openParticipantAdd() {
    this.storeSetBMParticipantEdited(new BMParticipantEditedViewModel())
  }

  openPlanAdd() {
    this.storeSetPlanByField(new BMPlanEditedViewModel())
  }

  openContractorAdd() {
    this.storeSetBMContractorEdited(new BMContractorEditedViewModel())
  }

  openCommentAdd() {
    this.storeSetBMCommentEdited({
      createTicket: false,
      deadline: null,
      description: null,
      subject: null,
      medias: []
    })
  }

  openIBAdd() {
    this.storeSetBMIBEdited(new BMIBEditedViewModel())
  }

  openParticipantUp(data) {
    if (data) {
      this.storeSetBMParticipantEdited({
        fk_entity: data.fk_entity,
        presence: data.presence,
        summon_next_meeting: data.summon_next_meeting,
        pid: data.id
      })
    } else {
      this.dtOpenBaseModal = false
    }
  }

  openPlanUp(data) { }

  openPlanSelector(cmt) {
    this.dtPlan.comment = cmt
  }

  openContractorUp(data) {
    if (data) {
      this.storeSetBMContractorEdited({
        fk_entity_contractor: data.contractor.fk_entity,
        date_start_work: data.date_start_work,
        date_end_work: data.date_end_work,
        progress: data.progress
      })
    }
  }

  openCommentUp(data) {
    if (data) {
      this.storeSetBMCommentEdited({
        createTicket: data.ticket !== null,
        deadline: data.ticket ? data.ticket.deadline : null,
        description: data.description,
        subject: data.subject,
      })
    }
  }

  openIBUp(data) { }

  openGenerateReport() {
    this.dtActionOpen = false
  }

  handleSave(event) {
    this.dtBaseModalLoading = true
    switch (this.dtBaseModalAction) {
      case this.ActionModal.MemberAdd:
        this.saveParticipant()
        break
      case this.ActionModal.PlanAdd:
        this.savePlan()
        break
      case this.ActionModal.ContractorAdd:
        this.saveContractor()
        break
      case this.ActionModal.CommentAdd:
        this.saveComment()
        break
      case this.ActionModal.IBAdd:
        this.saveIB()
        break
      case this.ActionModal.MemberUp:
        this.updateParticipant()
        break
      case this.ActionModal.PlanUp:
        this.updatePlan()
        break
      case this.ActionModal.PlanSelect:
        this.closePlan()
        break
      case this.ActionModal.ContractorUp:
        this.updateContractor()
        break
      case this.ActionModal.CommentUp:
        this.updateComment()
        break
      case this.ActionModal.IBUp:
        this.updateIB()
        break
      case this.ActionModal.GenerateReport:
        this.generateReport()
        break
    }
  }

  generateReport() {
    this.storeGenerateReport({ bmid: this.$route.params.id, idm: this.$route.params.idm })
      .then(response => {
        this.dtOpenBaseModal = false
        // update content for participant
        this.getCurrentMeeting()
      })
      .catch(err => {
        this.dtErrorModalVisible = true
        this.dtError = err
      })
      .finally(() => this.dtBaseModalLoading = false)
  }

  saveParticipant() {
    this.storePostParticipant({ bmid: this.$route.params.id, idm: this.$route.params.idm })
      .then(response => {
        this.dtOpenBaseModal = false
        // update content for participant
        // this.getCurrentMeeting()
      })
      .catch(err => {
        this.dtErrorModalVisible = true
        this.dtError = err
      })
      .finally(() => this.dtBaseModalLoading = false)
  }

  async savePlan() {
    if (this.document.attachments) {
      this.storeSaveDocument(this.document)
        .then(response => {
          response.map(async plan => {
            let imageSize = await this.getImageSize(plan.link)
            let planParam = {
              fk_plan_media: plan.id,
              height: plan.height || imageSize.height,
              width: plan.width || imageSize.width
            }
            this.storePostPlan({
              bmid: this.$route.params.id,
              idm: this.$route.params.idm,
              plan: planParam
            }).then(response => {
              this.getPlanMeeting()
            })
          })
        })
        .finally(() => {
          this.storeResetDocument()
          this.dtOpenBaseModal = false
          this.dtBaseModalLoading = false
        })
    } else if (this.bmPlanEdited.fk_plan_media) {
      this.storePostPlan({
        bmid: this.$route.params.id,
        idm: this.$route.params.idm
      }).then(response => {
        this.getPlanMeeting()
      }).finally(() => {
        this.storeResetDocument()
        this.dtOpenBaseModal = false
        this.dtBaseModalLoading = false
      })
    }
  }

  saveContractor() {
    this.storePostContractor({ bmid: this.$route.params.id, idm: this.$route.params.idm, idi: this.dtItemSelected.id })
      .then(response => {
        this.dtOpenBaseModal = false
        // update content for participant
        // this.getCurrentMeeting()
      })
      .catch(err => {
        this.dtErrorModalVisible = true
        this.dtError = err
      })
      .finally(() => this.dtBaseModalLoading = false)
  }

  async saveComment() {
    if (this.dtAttachments.length) {
      let promises = this.dtAttachments.map(file => {
        let fileParam = { files: [file] }
        return this.storePostMedia(fileParam)
          .then(response => { this.coFile = [...this.coFile, response[0].id] })
      })
      await Promise.all(promises).then(() => { this.dtAttachments = [] })
    }
    await this.storePostComment({
      bmid: this.$route.params.id,
      idm: this.$route.params.idm,
      idi: this.dtItemSelected.id
    })
      .then(response => {
        this.dtOpenBaseModal = false
        // update content for participant
        this.refreshComment(this.dtItemSelected.id)
      })
      .catch(err => {
        this.dtErrorModalVisible = true
        this.dtError = err
      })
      .finally(() => this.dtBaseModalLoading = false)
  }

  saveIB() {
    this.storePostIB({ bmid: this.$route.params.id, idm: this.$route.params.idm })
      .then(response => {
        this.dtOpenBaseModal = false
        this.comments.push({
          id: response.id,
          comments: []
        })
      })
      .catch(err => {
        this.dtErrorModalVisible = true
        this.dtError = err
      })
      .finally(() => this.dtBaseModalLoading = false)
  }

  updateParticipant() {
    if (!this.bmParticipantEdited.pid || (this.bmParticipantEdited.presence === this.dtItemSelected.presence &&
      this.bmParticipantEdited.summon_next_meeting === this.dtItemSelected.summon_next_meeting)) {
      this.dtOpenBaseModal = false
      this.dtBaseModalLoading = false
      return
    }
    this.storePatchParticipant({
      bmid: this.$route.params.id,
      idm: this.$route.params.idm,
      idp: this.bmParticipantEdited.pid.toString(),
      source: this.dtItemSelected
    })
      .then(response => {
        this.dtOpenBaseModal = false
        // update content for participant
        // this.getCurrentMeeting()
      })
      .catch(err => {
        this.dtErrorModalVisible = true
        this.dtError = err
      })
      .finally(() => this.dtBaseModalLoading = false)
  }

  updatePlan() { }

  closePlan() {
    this.dtBaseModalLoading = false
    this.dtOpenBaseModal = false
  }

  updateContractor() {
    if (!this.dtItemSelected.id ||
      (this.bmContractorEdited.date_start_work === this.dtItemSelected.date_start_work &&
        this.bmContractorEdited.date_end_work === this.dtItemSelected.date_end_work &&
        this.bmContractorEdited.progress === this.dtItemSelected.progress)) {
      this.dtOpenBaseModal = false
      this.dtBaseModalLoading = false
      return
    }
    this.storePatchContractor({
      bmid: this.$route.params.id,
      idm: this.$route.params.idm,
      idi: this.dtItemSelected.fk_bm_inspection_bundle,
      idc: this.dtItemSelected.id.toString(),
      source: this.dtItemSelected
    })
      .then(response => {
        this.dtOpenBaseModal = false
        // update content for participant
        // this.getCurrentMeeting()
      })
      .catch(err => {
        this.dtErrorModalVisible = true
        this.dtError = err
      })
      .finally(() => this.dtBaseModalLoading = false)
  }

  async updateComment() {
    if (this.dtAttachments.length) {
      let promises = this.dtAttachments.map(file => {
        let fileParam = { files: [file] }
        return this.storePostCommentMedia({
          bmid: this.$route.params.id,
          idm: this.$route.params.idm,
          idi: this.dtItemSelected.ibId.toString(),
          idc: this.dtItemSelected.id,
          params: fileParam
        })
          .then(response => { })
      })
      await Promise.all(promises).then(() => {
        this.dtAttachments = []
      })
      this.refreshComment(this.dtItemSelected.ibId)
    }
    let change = {
      createTicket: this.bmCommentEdited.createTicket && !this.dtItemSelected.ticket,
      deadline: (!this.dtItemSelected.ticket && this.bmCommentEdited.createTicket && this.bmCommentEdited.deadline) ||
        (this.dtItemSelected.ticket && this.dtItemSelected.ticket.deadline !== this.bmCommentEdited.deadline),
      description: this.bmCommentEdited.description !== this.dtItemSelected.description,
      subjet: this.bmCommentEdited.subject !== this.dtItemSelected.subject
    }
    if (!change.createTicket && !change.deadline && !change.description && !change.subjet) {
      this.dtOpenBaseModal = false
      this.dtBaseModalLoading = false
      return
    }
    this.storePatchComment({
      bmid: this.$route.params.id,
      idm: this.$route.params.idm,
      idi: this.dtItemSelected.ibId.toString(),
      idc: this.dtItemSelected.id,
      originalComment: this.dtItemSelected
    })
      .then(response => {
        this.dtOpenBaseModal = false
        // update content for participant
        // this.getCurrentMeeting()
        this.refreshComment(this.dtItemSelected.ibId)
      })
      .catch(err => {
        this.dtErrorModalVisible = true
        this.dtError = err
      })
      .finally(() => this.dtBaseModalLoading = false)
  }

  updateIB() { }

  handleClose() { }

  handleBeforeModalClose() {
    this.storeResetDocument()
    this.dtAttachments = []
  }

  getCurrentMeeting() {
    this.storeSetLoaderState({ key: BM_LOADERS.DETAILS, value: true })
    this.storeGetBMMeeting({ bmId: this.$route.params.id, idm: this.$route.params.idm })
      .then(response => {
        this.getMeetingComments()
      })
      .finally(() => {
        this.storeSetLoaderState({ key: BM_LOADERS.DETAILS, value: false })
      })
  }

  getPlanMeeting() {
    this.storeSetLoaderState({ key: BM_LOADERS.PLANS, value: true })
    this.storeGetBMMeetingPlan({ bmId: this.$route.params.id, idm: this.$route.params.idm })
      .then(response => {
        this.dtPlan.items = response.data
      })
      .finally(() => {
        this.storeSetLoaderState({ key: BM_LOADERS.PLANS, value: false })
      })
  }

  async getMeetingComments() {
    let inspections = this.bmMeeting.data.inspections.map(x => x)
    inspections.unshift(this.bmMeeting.data.generalComments)
    this.comments = []
    await inspections.map(async x => {
      let service = new BMService()
      await service.getMeetingIBComments(this.$route.params.id, this.$route.params.idm, x.id + '')
        .then(r => {
          this.comments.push({
            id: x.id,
            comments: r.data
          })
        })
    })
  }

  refreshComment(ibId) {
    let service = new BMService()
    service.getMeetingIBComments(this.$route.params.id, this.$route.params.idm, ibId + '')
      .then(r => {
        let indexComments = this.comments.findIndex(x => x.id === ibId)
        this.comments[indexComments].comments = r.data
      })
  }

  handleViewDocument(e: Event, link: string) {
    e.preventDefault()
    if (link) window.open(link)
  }

  getDateDuration(creation: string) {
    return DateTimeHelper.parseDateTimeCalendar(creation)
  }

  attachmentType(name: string) {
    if (!name) return ''
    if (name.split('/').length)
      name = name.split('/')[name.split('/').length - 1]
    const res = name.split('.')
    if (res && res[1]) return res[1]
    return ''
  }

  handleEditMeeting() {
    this.dtActionOpen = false
    this.storeEditMeeting()
  }

  handleDeleteMeeting() {
    this.storeSetBMAction(CrudStatus.Delete)
    this.dtActionOpen = false
  }


  handleDeleteIB(item) {
    this.dtActionOpen = false
    this.dtBaseModalAction = this.ActionModal.IBUp
    this.dtItemSelected = item
    this.openDeleteItem()
  }

  handleDeletePlan(item) {
    this.dtActionOpen = false
    this.dtBaseModalAction = this.ActionModal.PlanUp
    this.dtItemSelected = item
    this.openDeleteItem()
  }

  handleArchiveMeeting() {
    this.storeSetBMAction(CrudStatus.Archive)
    this.dtActionOpen = false
  }

  typeDocument(name) {
    let a = name.split('.')
    return a[a.length - 1]
  }

  nameFileDoc(name) {
    let s = name
    let n = s.lastIndexOf('.')
    s = s.substring(0, n !== -1 ? n : s.length)
    return s
  }

  handleRemoveError() {
    this.dtErrorModalVisible = false
    this.dtError = null
  }

  async getImageSize(url): Promise<any> {
    return new Promise(resolve => {
      let img = new Image()
      img.onload = () => {
        return resolve({
          width: img.width,
          height: img.height
        })
      }
      img.src = url
    })
  }
}

export default BMMeetingDetail



// WEBPACK FOOTER //
// ./src/containers/building-monitor/bm-meeting-detail/index.ts